'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M10.908 12.993c-.94-.18-1.75-.147-2.587.35-2.068 1.23-2.03 4.24.08 5.415 1.986 1.106 4.403-.187 4.643-2.422l-.005-15.081c-.002-.194.16-.205.316-.219.591-.053 1.638-.043 2.237 0 .08.006.159.01.234.046.502 2.406 2.587 4.36 5.095 4.344.02.006.079.16.079.174v4.342c0 .142-.72-.015-.834-.039-1.182-.24-2.294-.785-3.289-1.449v7.928c-.307 5.185-5.874 8.283-10.398 5.676a6.92 6.92 0 0 1-2.384-9.744c1.458-2.298 4.104-3.538 6.813-3.126z" /></svg>;
const IconSocialTiktok = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSocialTiktok;